import { useMutation } from "@tanstack/react-query";
import ExhibitorService from "../services"; // Adjust the import path based on your project structure
import { Exhibitor } from "../exhibitorType/Exhibitor";

const useUpdateExhibitor = () => {
  return useMutation({
    mutationFn: ({
      exhibitorId,
      updatedExhibitor,
    }: {
      exhibitorId: string;
      updatedExhibitor: Exhibitor;
    }) => ExhibitorService.update(exhibitorId, updatedExhibitor), // Calling the update method from EventService
    onSuccess: () => {
      console.log("Event updated successfully!");
    },
    onError: (error) => {
      console.error("Error updating event:", error);
    },
  });
};

export default useUpdateExhibitor;